"use client";

import { motion } from "framer-motion";

export default function AppDownloadCTA() {
    return (
        <section className="bg-black text-white pt-10 md:pt-16 pb-16 md:pb-24">
            <div className="container mx-auto px-6 md:px-20 lg:px-40 flex flex-col items-start text-left">

                {/* Heading */}
                <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold tracking-tighter text-white mb-6 leading-[0.9]">
                    Ecosystems
                </h2>
                <p className="text-lg sm:text-xl md:text-2xl text-gray-400 font-light leading-relaxed max-w-2xl mb-12 md:mb-16">
                    We build native and hybrid applications that provide seamless experiences across all major platforms.
                </p>

                {/* Cards Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-6xl text-left">

                    {/* Apple Card */}
                    <motion.div
                        whileHover={{ scale: 1.02 }}
                        className="bg-[#151515] text-white p-6 lg:p-8 rounded-[30px] md:rounded-[40px] flex flex-col gap-10 md:gap-0 justify-between md:min-h-[360px] items-start text-left shadow-2xl cursor-pointer"
                    >
                        {/* Apple Icon */}
                        <svg className="w-10 h-10 fill-white md:mb-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.23-3.14-2.42-1.75-2.51-3.08-7.04-1.28-10.16 0.88-1.54 2.48-2.51 4.18-2.54 1.3-.03 2.52.88 3.3.88.78 0 2.22-1.09 3.75-0.93 0.63.03 2.43.25 3.57 1.94-0.1 0.05-2.12 1.25-2.1 3.76s1.67 3.01 1.76 3.05zm-4.32-15.08c0.69-0.84 1.15-2.02 1.04-3.19-1.02.04-2.27.68-2.99 1.54-0.65.75-1.2 1.98-1.05 3.13 1.14.09 2.31-0.61 3-1.48z" />
                        </svg>

                        <div className="mt-auto">
                            <span className="block text-xs font-bold text-gray-500 mb-2 uppercase tracking-widest">iOS</span>
                            <span className="block text-2xl font-bold tracking-tight mb-3">Apple Ecosystem</span>
                            <p className="text-gray-400 text-sm leading-relaxed font-medium">
                                Native Swift applications that feel right at home on every iPhone and iPad.
                            </p>
                        </div>
                    </motion.div>

                    {/* Google Play Card */}
                    <motion.div
                        whileHover={{ scale: 1.02 }}
                        className="bg-[#151515] text-white p-6 lg:p-8 rounded-[30px] md:rounded-[40px] flex flex-col gap-10 md:gap-0 justify-between md:min-h-[360px] items-start text-left shadow-2xl cursor-pointer"
                    >
                        {/* Play Store Icon */}
                        <svg className="w-10 h-10 fill-white md:mb-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 3.85902V20.141C5 20.84 5.79054 21.2482 6.36863 20.8477L11.5318 17.2721L17.5 13.1332L6.37568 3.14917C5.79726 2.74706 5 3.15546 5 3.85902Z" fill="#fff" />
                            <path d="M18.6667 14.1843L12.3333 17.8281L11.5318 17.2721L17.5 13.1332L18.6667 14.1843Z" fill="#fff" fillOpacity="0.6" />
                        </svg>

                        <div className="mt-auto">
                            <span className="block text-xs font-bold text-gray-500 mb-2 uppercase tracking-widest">Android</span>
                            <span className="block text-2xl font-bold tracking-tight mb-3">Google Play</span>
                            <p className="text-gray-400 text-sm leading-relaxed font-medium">
                                Kotlin-first development ensuring consistent performance across all devices.
                            </p>
                        </div>
                    </motion.div>

                    {/* Universal Card */}
                    <motion.div
                        whileHover={{ scale: 1.02 }}
                        className="bg-[#151515] text-white p-6 lg:p-8 rounded-[30px] md:rounded-[40px] flex flex-col gap-10 md:gap-0 justify-between md:min-h-[360px] items-start text-left shadow-2xl cursor-pointer"
                    >
                        {/* Dot Matrix Pattern */}
                        <div className="w-[60px] h-[60px] grid grid-cols-5 gap-1.5 md:mb-6">
                            {Array.from({ length: 25 }).map((_, i) => (
                                <div key={i} className={`rounded-full bg-white ${i % 2 === 0 ? 'opacity-30' : 'opacity-90'} w-full h-full`} />
                            ))}
                        </div>

                        <div className="mt-auto">
                            <span className="block text-xs font-bold text-gray-500 mb-2 uppercase tracking-widest">Hybrid</span>
                            <span className="block text-2xl font-bold tracking-tight mb-3">Universal</span>
                            <p className="text-gray-400 text-sm leading-relaxed font-medium">
                                React Native & Flutter solutions for rapid deployment on both platforms.
                            </p>
                        </div>
                    </motion.div>

                </div>
            </div>
        </section>
    );
}
